// extracted by mini-css-extract-plugin
module.exports = {"container":"awards_container__3ICQz","link":"awards_link__2TuwY","award":"awards_award__11I48","textSectionInfo":"awards_textSectionInfo__HIRty","warImg":"awards_warImg__q1Dpf"};